import { motion } from 'framer-motion'
import React from 'react'
import {
  StyledA,
  StyledButton,
  StyledForm,
  StyledBlockquote,
  StyledGatsbyLink,
  StyledH1,
  StyledH2,
  StyledH3,
  StyledInput,
  StyledLI,
  StyledNav,
  StyledP,
  StyledSection,
  StyledSpan,
  StyledUL,
} from './styles'

const H1 = ({ children, animated, ...rest }) => {
  return (
    <StyledH1
      fontSize={['40px', null, '64px']}
      fontFamily="headings"
      color='tanDark'
      fontWeight={700}
      lineHeight={["47px", null, "76px"]}
      as={animated && motion.h1}
      {...rest}
    >
      {children}
    </StyledH1>
  )
}

const H2 = ({ children, animated, ...rest }) => {
  return (
    <StyledH2
      fontSize={['20px', null, null, '40px']}
      fontFamily="headings"
      fontWeight={700}
      lineHeight="47px"
      color="tanDark"
      as={animated && motion.h2}
      {...rest}
    >
      {children}
    </StyledH2>
  )
}

const H3 = ({ children, ...rest }) => {
  return (
    <StyledH3
      fontSize={['20px', null, '40px']}
      fontFamily="headings"
      fontWeight={700}
      lineHeight="47px"
      color="tanDark"
      {...rest}
    >
      {children}
    </StyledH3>
  )
}

const Section = ({ children, animated, ...rest }) => {
  return (
    <StyledSection
      as={animated && motion.section}
      {...rest}
    >
      {children}
    </StyledSection>
  )
}

const Nav = ({ children, ...rest }) => {
  return <StyledNav {...rest}>{children}</StyledNav>
}

const Paragraph = ({ children, animated, ...rest }) => {
  return (
    <StyledP
      fontSize={['16px']}
      fontFamily="body"
      fontWeight={300}
      lineHeight="28px"
      letterSpacing="0.02em"
      color="tanLight"
      as={animated && motion.p}
      {...rest}
    >
      {children}
    </StyledP>)
}

const Blockquote = ({ children, ...rest }) => {
  return (
    <StyledBlockquote {...rest}>
      {children}
    </StyledBlockquote>)
}

const Anchor = ({ children, target, animated, ...rest }) => {
  return (
    <StyledA
      target={target || '_blank'}
      as={animated && motion.a}
      {...rest}
    >
      {children}
    </StyledA>
  )
}

const Span = ({ children, ...rest }) => {
  return <StyledSpan {...rest}>{children}</StyledSpan>
}

const Link = ({ children, ...rest }) => {
  return <StyledGatsbyLink {...rest}>{children}</StyledGatsbyLink>
}

const UL = ({ children, ...rest }) => {
  return <StyledUL {...rest}>{children}</StyledUL>
}

const LI = ({ children, ...rest }) => {
  return <StyledLI {...rest}>{children}</StyledLI>
}

const Form = ({ children, animated, ...rest }) => {
  return <StyledForm as={animated && motion.form} {...rest}>{children}</StyledForm>
}

const Input = ({ children, ...rest }) => {
  return <StyledInput {...rest}>{children}</StyledInput>
}

const Button = ({ children, ...rest }) => {
  return <StyledButton {...rest}>{children}</StyledButton>
}

export {
  H1,
  H2,
  H3,
  Section,
  Nav,
  Paragraph,
  Blockquote,
  Anchor,
  Span,
  Link,
  UL,
  LI,
  Form,
  Input,
  Button
}
